import { AgentAttachedTrack } from './agentAttachedTrack';

/**
 * What has been typed but not yet sent, kept per open chat tab. Two DJs' worth
 * of half-written questions must not bleed into each other when tabs are
 * switched, and the draft has to survive leaving the homepage the same way the
 * conversation itself does.
 *
 * This sits outside React on purpose: a keystroke should re-render the composer
 * and nothing else, so holding drafts in the session context would repaint the
 * whole rail on every character.
 */

export type AgentComposerDraft = {
  text: string;
  /** Seed track shown as a card in the composer (sent as track context). */
  tracks: AgentAttachedTrack[];
};

/** The blank slate before a conversation exists; it keeps a draft too. */
export const NEW_CHAT_DRAFT_KEY = 'new-chat';

const drafts = new Map<string, AgentComposerDraft>();

export const readComposerDraft = (key: string): AgentComposerDraft | null =>
  drafts.get(key) ?? null;

export const saveComposerDraft = (
  key: string,
  draft: AgentComposerDraft,
): void => {
  // Whitespace alone is not worth restoring; a track-only draft still is.
  if (!draft.text.trim() && draft.tracks.length === 0) {
    drafts.delete(key);
    return;
  }
  drafts.set(key, {
    text: draft.text,
    tracks: draft.tracks.slice(0, 1),
  });
};

export const clearComposerDraft = (key: string): void => {
  drafts.delete(key);
};
